import React from 'react';
import '../css/ComingSoon.css';

const ComingSoon = () => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <h1 className="coming-soon-title">🚀 We Are Coming Soon!</h1>
        <p className="coming-soon-subtitle">
          This section is launching soon. We’re working behind the scenes to bring you something amazing.
        </p>
        <p className="coming-soon-footer">Stay tuned! 🔴 Red Fibre</p>
      </div>
    </div>
  );
};

export default ComingSoon;